import { FC } from 'react'
import styles from './styles.module.scss'
import { QuestionnaireResource } from '../../index'
import { DynamicImage } from '@/components/DynamicImage'
import Link from 'next/link'

export const AnswerResource: FC<QuestionnaireResource> = ({ sys, fields }) => {
  const { metaTitle, slug, heroImage } = fields
  const contentType = sys.contentType.sys.id

  const getRelativeUrl = (contentType: string, slug: string): string => {
    switch (contentType) {
      case 'blogPost':
        return `/blog/${slug}/`
      case 'landingPage':
        return `/${slug}/`
      default:
        return `/${slug}/`
    }
  }

  return (
    <Link
      aria-label={metaTitle}
      className={styles.cardLink}
      href={getRelativeUrl(contentType, slug)}
      key={slug}
    >
      <div className={styles.card}>
        {heroImage && (
          <DynamicImage
            className={styles.image}
            image={heroImage}
            alt={heroImage.fields.title}
            width={heroImage.fields.file.details.image.width}
            height={heroImage.fields.file.details.image.height}
            sizes="(max-width: 720px) 100vw, (max-width: 1080px) 50vw, 33vw"
          />
        )}
        <div className={styles.text}>
          <div className={styles.titles}>
            <h5>{metaTitle}</h5>
          </div>
          <div className={styles.meta}>
            <div>
              {contentType === 'blogPost' ? 'Blog Post' : 'Website Resource'}
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
